import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { RoutesLinks } from 'components/routes-links'

const PrivateRoute = ({ children, ...rest }) => {
  const authInfo = useSelector((state) => state.auth)
  const { token } = authInfo

  return (
    <Route
      {...rest}
      render={(props) =>
        token
          ? (
              children
            )
          : (
          <Redirect
            to={{
              pathname: RoutesLinks.LOGIN_LINK,
              state: { from: props.location }
            }}
          />
            )
      }
    />
  )
}

export default PrivateRoute
